package com.gsb.vyapar.bhagya.presentation.category.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material.Checkbox
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.common.button.GVBButton
import com.gsb.vyapar.bhagya.presentation.common.edittext.CategoryNameEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14Regular
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBold
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.util.ADD_URL
import com.gsb.vyapar.bhagya.util.orEmpty
import com.gsb.vyapar.bhagya.util.value
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import kotlinx.coroutines.launch

@Composable
fun AddEditCategoryView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    val coroutineScope = rememberCoroutineScope()
    val imagePickerLauncher = rememberFilePickerLauncher(PickerType.Image) { selectedImage ->
        coroutineScope.launch { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditCategoryImageUpload(selectedImage?.readBytes().orEmpty(), selectedImage?.name.orEmpty()))) }
    }
    LazyColumn(modifier = Modifier.padding(16.dp), horizontalAlignment = Alignment.CenterHorizontally) {
        item {
            Spacer(Modifier.height(8.dp))
            Text24SemiBold("Add/Edit Category", black)
            Spacer(Modifier.height(8.dp))
            CategoryNameEditText(uiState.categoriesViewUiState.addEditCategory.name, "Enter Category Name") {
                onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditCategoryName(it)))
            }
            Spacer(Modifier.height(16.dp))
            uiState.getImage(uiState.categoriesViewUiState.addEditCategory.imageUrl.ifEmpty { ADD_URL.value() })?.let { imageBitmap ->
                CommonImage(imageBitmap, 50.dp, 50.dp, Modifier.clickable { imagePickerLauncher.launch() })
            }
            Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                Checkbox(uiState.categoriesViewUiState.addEditCategory.deleted, onCheckedChange = {
                    onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditCategoryDeleted(it)))
                })
                Text14Regular("Deleted", black)
            }
            GVBButton(text = "Save", onClick = { onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.AddEditCategorySave)) })
        }
    }
}